export const en = {
    'accept-button': 'Enable',
    'simple-progress-hint': 'Enabling autotargeting',
    'simple-title': 'Enable autotargeting',
    'title-hint': 'The recommendation is shown because your ads have no keywords configured or the CPC is too high'
};
